import { Injectable, signal } from '@angular/core';
import { Building, CalculationBase, CalculationSummary, Level } from '../../models';
import { DefaultValues } from '../../models/default-values.interface';
import { DEFAULT_ROOM_HEIGHT } from '../../consts';
import { ApiHeatLoadCalculation } from '../../models';
import { BuildingType } from '../../../../lib';

@Injectable({
    providedIn: 'root'
})
export class BuildingStore {
    private _buildingSignal = signal<Building | null>(null);
    private _levelsSignal = signal<Level[]>([]);
    private _calculationSummarySignal = signal<CalculationSummary | undefined>(undefined);
    private _calculationBaseSignal = signal<CalculationBase>({ totalLivingArea: 0, includeTotalBuilding: false });
    private _defaultValuesSignal = signal<DefaultValues>({ levelHeight: DEFAULT_ROOM_HEIGHT });
    private _hasMultipleA2APlanningsSignal = signal<boolean>(false);
    private _drawerLoadingSignal = signal<boolean>(false);
    private _drawerErrorSignal = signal<boolean>(false);
    private _loadingSignal = signal<boolean>(false);
    private _errorSignal = signal<boolean>(false);
    private _activeProjectIdSignal = signal<string | null>(null);
    private _buildingTypeSignal = signal<BuildingType | undefined>(undefined);
    private _apiHeatLoadCalculationsSignal = signal<ApiHeatLoadCalculation[]>([]);

    public readonly building = this._buildingSignal.asReadonly();
    public readonly levels = this._levelsSignal.asReadonly();
    public readonly calculationSummary = this._calculationSummarySignal.asReadonly();
    public readonly calculationBase = this._calculationBaseSignal.asReadonly();
    public readonly defaultValues = this._defaultValuesSignal.asReadonly();
    public readonly hasMultipleA2APlannings = this._hasMultipleA2APlanningsSignal.asReadonly();
    public readonly drawerLoading = this._drawerLoadingSignal.asReadonly();
    public readonly drawerError = this._drawerErrorSignal.asReadonly();
    public readonly loading = this._loadingSignal.asReadonly();
    public readonly error = this._errorSignal.asReadonly();
    public readonly activeProjectId = this._activeProjectIdSignal.asReadonly();
    public readonly buildingType = this._buildingTypeSignal.asReadonly();
    public readonly apiHeatLoadCalculations = this._apiHeatLoadCalculationsSignal.asReadonly();

    public setActiveProjectId(id: string | null): void {
        this._activeProjectIdSignal.set(id);
    }

    public setBuildingType(type: BuildingType | undefined): void {
        this._buildingTypeSignal.set(type);
    }

    public setApiHeatLoadCalculations(calculations: ApiHeatLoadCalculation[]): void {
        this._apiHeatLoadCalculationsSignal.set(calculations);
    }

    public setBuilding(building: Building | null): void {
        this._buildingSignal.set(building);
    }

    public setLevels(levels: Level[]): void {
        this._levelsSignal.set(levels);
    }

    public setCalculationSummary(summary: CalculationSummary | undefined): void {
        this._calculationSummarySignal.set(summary);
    }

    public setCalculationBase(base: CalculationBase): void {
        this._calculationBaseSignal.set(base);
    }

    public setDefaultValues(values: DefaultValues): void {
        this._defaultValuesSignal.set(values);
    }

    public setHasMultipleA2APlannings(value: boolean): void {
        this._hasMultipleA2APlanningsSignal.set(value);
    }

    public setDrawerLoading(value: boolean): void {
        this._drawerLoadingSignal.set(value);
    }

    public setDrawerError(value: boolean): void {
        this._drawerErrorSignal.set(value);
    }

    public setLoading(value: boolean): void {
        this._loadingSignal.set(value);
    }

    public setError(value: boolean): void {
        this._errorSignal.set(value);
    }
}
